export default __webpack_public_path__ + "static/media/toggleOffDisabled.a455065f.svg";